import 'twin.macro'
import React, { Fragment, useRef } from 'react'
import { Combobox } from '@headlessui/react'
import * as Portal from '@radix-ui/react-portal'
import { CgChevronDown } from 'react-icons/cg'

import { usePopper } from 'common/hooks/usePopper'
import { inputBase } from 'common/components/Input/Input'
import { SuggestionContainer, SuggestionItem } from 'common/components/Suggestions/Suggestions'
import { capitalizeFirstLetter } from 'common/utils/stringUtils'

export const accessUnitOptions = { year: 'year', month: 'month' }

export default function AccessPeriodInput({ inputRef, value, setValue, accessValueErr, setError }) {
  const comboboxBtnRef = useRef()

  const handleSelect = (newValue) => {
    setValue('accessUnit', newValue)
    if (value !== newValue && accessValueErr) {
      setError('accessValue', { message: `Number of ${newValue}s must be more than 0` })
    }
  }

  const handleInputKeyDown = (e) => {
    const acceptedCodes = ['Enter', 'Tab', 'ArrowUp', 'ArrowDown']
    if (!acceptedCodes.includes(e.code)) {
      e.preventDefault()
    } else if (e.code === 'Enter' && !e.shiftKey) {
      comboboxBtnRef.current.click()
    }
  }

  let [popperTrigger, popperContainer] = usePopper({
    placement: 'bottom-start',
    strategy: 'fixed',
  })

  const inputWidth = inputRef?.current?.getBoundingClientRect()?.width
  return (
    <Combobox value={value} onChange={handleSelect}>
      <div ref={popperTrigger} className='w-full'>
        <Combobox.Button ref={comboboxBtnRef} as='div' className='relative w-full'>
          <Combobox.Input
            ref={(e) => {
              inputRef.current = e
            }}
            placeholder='Select access period'
            autoComplete='off'
            displayValue={(value) => capitalizeFirstLetter(value) || 'Select access period'}
            onKeyDown={handleInputKeyDown}
            className='text-ellipsis bg-inherit cursor-pointer'
            css={inputBase}
          />
          <CgChevronDown className='absolute right-4 top-1/2 -translate-y-1/2 cursor-pointer text-gray-500 w-4 h-4' />
        </Combobox.Button>
      </div>
      <Portal.Root>
        <Combobox.Options className='z-[999]' ref={popperContainer} modal={false}>
          <SuggestionContainer containerStyle={{ width: inputWidth }}>
            {Object.values(accessUnitOptions).map((opt) => (
              <Combobox.Option as={Fragment} key={opt} value={opt}>
                {({ selected, active }) => (
                  <SuggestionItem active={active}>{capitalizeFirstLetter(opt)}</SuggestionItem>
                )}
              </Combobox.Option>
            ))}
          </SuggestionContainer>
        </Combobox.Options>
      </Portal.Root>
    </Combobox>
  )
}
